<template>
  <div class="content">
    <div class="form">
      <div class="form-group">
        <label>Nhập họ và tên</label>
        <input v-model="name" class="form-control" placeholder="Nhập tên của bạn"/>
      </div>

      <div class="form-group">
        <label>Ngày sinh Dương lịch (Định dạng ngày/tháng/năm)</label>
        <input v-model="birthday" class="form-control" placeholder="Nhập tên của bạn"/>
      </div>

      <div class="form-group gio-sinh">
        <label>Giờ sinh</label>
        <input v-model="hour" type="number" min="0" max="23" class="form-control t-select"/>
        <span>Giờ </span>
        <input v-model="minute" type="number" min="0" max="59" class="form-control t-select"/>
        <span>Phút</span>
      </div>
      <div class="form-group" style="text-align: center;">
        <p>
          <input type="radio" id="test1" value="1" v-model="gender">
          <label for="test1">Nam</label>
        </p>
        <p>
          <input type="radio" id="test2" value="0" v-model="gender">
          <label for="test2">Nữ</label>
        </p>
      </div>

      <div class="form-group" style="text-align: center;">
        <p>
          <input type="radio" id="type1" value="1" v-model="type">
          <label for="type1">Chi tiết</label>
        </p>
        <p>
          <input type="radio" id="type2" value="0" v-model="type">
          <label for="type2">Luận đoán</label>
        </p>
      </div>
      <button class="btn" @click="onSubmit">Gửi</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  data () {
    return {
      name: 'Cu Tí',
      birthday: '05/02/1996',
      hour: '00',
      minute: '00',
      gender: 1,
      type: 1
    }
  },
  methods: {
    onSubmit () {
      const data = {
        name: this.name,
        birthday: this.birthday,
        hour: this.hour,
        minute: this.minute,
        gender: this.gender,
        type: this.type
      }
      this.$emit('input', data)
    }
  }
}
</script>
